// @flow

import * as React from 'react'

export const StartIcon = (props: { className?: string }) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={36}
    height={36}
    className={props.className}
  >
    <g fill="none" fillRule="evenodd">
      <rect width={36} height={36} fill="#d164c5" rx={18} />
      <path
        fill="#fff"
        d="M13 11.994c0-1.101.773-1.553 1.745-.997l10.51 6.005c.964.55.972 1.439 0 1.994l-10.51 6.007c-.964.55-1.745.102-1.745-.997V11.994z"
      />
    </g>
  </svg>
)
